import { ButtonHTMLAttributes, PropsWithChildren } from 'react'

import { cn } from '@/lib/utils/client'

const Button: React.FC<
  PropsWithChildren<
    {
      className?: string
      sm?: boolean
      primary?: boolean
    } & ButtonHTMLAttributes<HTMLButtonElement>
  >
> = ({ children, sm, primary, ...props }) => {
  return (
    <button
      {...{
        ...props,
        className: cn(
          primary
            ? 'group text-white bg-black flex items-center gap-2 text-base'
            : 'flex h-10 items-center justify-center rounded-md border border-gray-200 bg-gray-50 px-3.5 text-base font-medium text-gray-900 select-none hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-100 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400',
          sm ? 'text-sm p-2' : 'p-3 ',
          props.className
        )
      }}
    >
      {children}
    </button>
  )
}

export default Button
